import { Box, Grid, TextField } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { dateformat, soloNumero } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import { FechaField } from '../../../accesos/components/FechaField';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import SelectFieldDeportesComponent from '../../../sistema/deportes/components/SelectFieldDeportes';
import { saveTorneosAction } from '../TorneosAction';

const FormTorneos = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const torneosStore = Redux.useSelector((state) => state.torneos);

  const activo = torneosStore.activo;

  const initData = {
    nombre: '',
    lugar: '',
    equipos: '',
    fecha: '',
    desc: '',
    idDeporte: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    equipos: false,
    lugar: false,
    fecha: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idDeporte: torneosStore.activo.deporte.id,
          idEstatus: activo.estatus.id,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!data.idDeporte) {
      notify('Falta seleccionar un deporte', { warning: true });
      return;
    }

    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveTorneosAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idEntidad: entidadesStore.activo.id,
        },
        torneosStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={12}>
          <SelectFieldDeportesComponent
            value={data.idDeporte}
            required
            onChange={(idDeporte) =>
              _handleSetDataField(CONST.deporte.idName, idDeporte)
            }
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nombre.name}
            required
            label={CONST.nombre.label}
            value={data.nombre}
            onChange={(e) =>
              _handleSetDataField(
                CONST.nombre.name,
                e.target.value.toUpperCase(),
              )
            }
            helperText={dataError.nombre ? validMessage.required : null}
            error={dataError.nombre}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            type="number"
            fullWidth
            size="small"
            id={CONST.equipos.name}
            required
            label={CONST.equipos.tag}
            value={data.equipos}
            onChange={(e) =>
              _handleSetDataField(
                CONST.equipos.name,
                soloNumero(e.target.value),
              )
            }
            helperText={dataError.equipos ? validMessage.required : null}
            error={dataError.equipos}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FechaField
            notDate
            views={['year', 'month', 'day']}
            openTo="month"
            botonCurrentDate={false}
            label={CONST.fecha.tag}
            value={data.fecha}
            error={dataError.fecha}
            onChange={(e) =>
              _handleSetDataField(CONST.fecha.name, dateformat(e, {}))
            }
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
            required
            error={dataError.estatus}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.lugar.name}
            label={CONST.lugar.label}
            value={data.lugar}
            multiline
            required
            rows={2}
            onChange={(e) =>
              _handleSetDataField(CONST.lugar.name, e.target.value)
            }
            helperText={dataError.lugar ? validMessage.required : null}
            error={dataError.lugar}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={2}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
            helperText={dataError.desc ? validMessage.required : null}
            error={dataError.desc}
          />
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormTorneos;
